import React, { useEffect } from "react";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Form from "./pages/Form";
import Campers from "./pages/Campers";
import PrivateRoutes from "./utils/PrivateRoutes";
import Admin from "./pages/Admin";
import PasswordReset from "./pages/PasswordReset";
import AdminRoutes from "./utils/AdminRoutes";
import Test from "./pages/Test";
import Checkout from "./pages/Checkout";
import Payment from "./pages/Payment";
import TestRoute from "./utils/TestRoute.js";
import Contact from "./pages/Contact.js";
import TermsOfService from "./pages/TermsOfService.js";
import NotFoundPage from "./pages/NotFoundPage";
import GroupFormation from "./pages/GroupFormation.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import PDFViewer from "./pages/PDFViewer.js";
import CampInfo from "./pages/CampInfo.js";
import {
  DiscordWebhookVisitorDetected,
  DiscordWebhookLoginDetected,
} from "@api/discord/discordWebhooks.js";
import { DeveloperMode } from "./config/DeveloperMode.js";
import { isUserLoggedIn } from "@utils/auth.js";
import { unsubscribeAllChannels } from "@db/subscribe.js";
import PDF from "./docs/Schedule.pdf";
import MenuBar from "@components/MenuBar.js";

// function setupAutoRefresh() {
//   // 1. Refresh every 5 minutes
//   const interval = setInterval(() => {
//     window.location.reload();
//   }, 5 * 60 * 1000); // 5 minutes

//   // 2. Refresh when tab becomes active again
//   const handleVisibilityChange = () => {
//     if (document.visibilityState === 'visible') {
//       window.location.reload();
//     }
//   };
//   // document.addEventListener('visibilitychange', handleVisibilityChange);

//   // 3. Refresh after 1 minute of inactivity
//   let inactivityTimer;
//   const resetInactivityTimer = () => {
//     clearTimeout(inactivityTimer);
//     inactivityTimer = setTimeout(() => {
//       window.location.reload();
//     }, 60 * 1000); // 1 minute
//   };

//   ['mousemove', 'keydown', 'scroll', 'click'].forEach((event) =>
//     window.addEventListener(event, resetInactivityTimer)
//   );
//   resetInactivityTimer(); // start the first timer

//   // Clean up everything
//   return () => {
//     clearInterval(interval);
//     document.removeEventListener('visibilitychange', handleVisibilityChange);
//     ['mousemove', 'keydown', 'scroll', 'click'].forEach((event) =>
//       window.removeEventListener(event, resetInactivityTimer)
//     );
//     clearTimeout(inactivityTimer);
//   };
// }

function App() {
  useEffect(() => {
    const fetchUser = async () => {
      if (DeveloperMode()) return;

      let hours = 1;
      let calcHours = hours * 60 * 60 * 1000;
      let now = new Date().getTime();
      let setupTime = localStorage.getItem('setupTime');

      if (setupTime == null || now - setupTime > calcHours) {
        if (await isUserLoggedIn()) await DiscordWebhookLoginDetected();
        else await DiscordWebhookVisitorDetected();
        localStorage.setItem('setupTime', now);
      }
    };

    fetchUser();

    // const cleanup = setupAutoRefresh(); // ✅ call it here

    return () => {
      // cleanup(); // ✅ clean up on unmount
    };
  }, []);

  const nav = useNavigate();

  useEffect(() => {
    return () => {
      unsubscribeAllChannels();
    };
  }, [nav]);

  return (
    <>
      <MenuBar />
      <div className='body-content'>
        <Routes>
          <Route element={<AdminRoutes />}>
            {" "}
            {/*All nested protected Admin pages */}
            <Route path='/admin' element={<Admin />} />
          </Route>
          <Route element={<PrivateRoutes />}>
            {" "}
            {/*All nested protected pages */}
            <Route path='/profile' element={<Profile />} />
            <Route path='/campers' element={<Campers />} />
            <Route path='/form' element={<Form />} />
            <Route path='/addCamper' element={<Form addCamperPage />} />
            <Route path='/checkout' element={<Checkout />} />
            <Route path='/payment' element={<Payment />} />
            <Route path='/schedule' element={<PDFViewer pdf={PDF} />} />
          </Route>
          <Route element={<TestRoute />}>
            <Route path='/test' element={<Test />} />
          </Route>
          <Route path='/' element={<Home />} exact />
          <Route path='/camp-info' element={<CampInfo />} />
          <Route path='/about' element={<About />} />
          <Route path='/pricing' element={<Pricing />} />
          <Route path='/login' element={<Login />} />
          <Route path='/signup' element={<Register />} />
          <Route path='/password-reset' element={<PasswordReset />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/terms-of-service' element={<TermsOfService />} />
          <Route path='/group-formation' element={<GroupFormation />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='*' element={<NotFoundPage />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
}

export default App;
